import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { ChatMessage } from '../types'
import MarkdownMessage from './MarkdownMessage'

interface ChatMessageBubbleProps {
  message: ChatMessage
}

const ChatMessageBubble: React.FC<ChatMessageBubbleProps> = ({ message }) => {
  const isUser = message.role === 'user'

  return (
    <Flex justify={isUser ? 'flex-end' : 'flex-start'} mb={3} px={2}>
      <Box
        maxW="80%"
        bg={isUser ? 'brand.500' : 'gray.100'}
        color={isUser ? 'white' : 'gray.800'}
        px={4}
        py={3}
        borderRadius="lg"
        borderBottomRightRadius={isUser ? 'sm' : 'lg'}
        borderBottomLeftRadius={isUser ? 'lg' : 'sm'}
        boxShadow="sm"
      >
        {isUser ? (
          <Text fontSize="sm" whiteSpace="pre-wrap" lineHeight="1.6">
            {message.content}
          </Text>
        ) : (
          <MarkdownMessage content={message.content} />
        )}
        <Text fontSize="xs" color={isUser ? 'whiteAlpha.700' : 'gray.400'} mt={1} textAlign="right">
          {new Date(message.timestamp).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          })}
        </Text>
      </Box>
    </Flex>
  )
}

export default ChatMessageBubble
